export default "__VITE_ASSET__BeWqGWri__"